import { SUBSCRIBE_FORM_COOKIE_PREFIX } from '../constants';

export function getHasSubscribedCookieName(formId: number) {
    return `${SUBSCRIBE_FORM_COOKIE_PREFIX}${formId}`;
}
